<template>

  <v-form ref="form">

    <h2>Responsável financeiro</h2>
    <h3 class="text-secondary">Prefered name on invoice</h3>

    <v-text-field
      outline class="mt-4"
      v-model="resource.form.financial_responsible_name"
      :rules="[rules.required]"
      label="RESPONSÁVEL FINANCEIRO/ PREFERED NAME ON INVOICE"
    />

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          v-model="resource.form.financial_responsible_document"
          :rules="[rules.required, rules.cpf]"
          mask="###.###.###-##"
          label="CPF"
        />
      </v-flex>
    </v-layout>

  </v-form>
</template>

<script>
import * as cpfValidation from '@/helpers/cpfValidation'

/**
 * @group Form
 * Componente de form para dados financeiros de responsavel
 */
export default {
  name: 'FormResponsibleFinances',

  inject: ['resource'],

  data: () => ({
    rules: {
      required: v => !!v || 'Campo obrigatório/Field is required',
      cpf: value => {
        return cpfValidation.validate(value || '') || 'CPF Inválido/CPF Invalid'
      }
    }
  }),

  computed: {
    resource () {
      return this.resource
    }
  },

  methods: {
    /**
     * @vuese
     * Método para validação da form
     */
    validateForm () {
      return this.$refs.form.validate()
    }
  }
}
</script>
